import { ErrorState } from './call-state.model';

export class ElioError {
  cause: string;
  messageKey: string;
  details: Record<string, string>;

  constructor(cause: string, messageKey: string, details?: Record<string, string>) {
    this.cause = cause;
    this.messageKey = messageKey;
    this.details = details ?? {};
  }
}

export interface EsuiteErrorResponse {
  code: string;
  message: string;
  details: Record<string, string>;
}

export const toElioError = (error: unknown): ElioError => {
  console.error(error);
  if (error instanceof ElioError) return error;
  return new ElioError(UNKNOWN_ERROR_CAUSE, 'toast.error.unknown');
};

export const UNKNOWN_ERROR_CAUSE = 'UNKNOWN_ERROR';
export const EMPTY_ERROR = new ElioError(UNKNOWN_ERROR_CAUSE, 'an error occured');
export const EMPTY_ERROR_STATE: ErrorState = { error: EMPTY_ERROR };
